import { Box, Tag } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const CommodityHeaderStyled = styled(Box).attrs({
  py: { sm: '200' },
})`
  ${({ theme }) => css`
    height: ${theme.componentStyles.pageHeaderHeight};
    box-shadow: ${theme.componentStyles.boxShadow};
    align-items: center;
    position: relative;
  `};
`;

export const TagStyled = styled(Tag)`
  ${({ theme }) => css`
    background-color: ${theme.colors.primary[700]};
    font-size: ${theme.fontSizes[300]};
    margin-left: ${theme.spacings[450]};
    padding-top: ${theme.spacings[200]};
    padding-right: ${theme.spacings[550]};
    padding-bottom: ${theme.spacings[300]};
    padding-left: ${theme.spacings[550]};
    border-radius: ${theme.radii[500]};
  `};
`;
